import {Helmet} from "react-helmet";
import classes from "../../../css/styles.module.scss";
import planner from "./planner.png";
import chat from "./chat.png";
const Tourism = () => {
  return (
    <div>
      <Helmet><title>Backend Helpers Limited | Productos | Eco-Rolling AI</title></Helmet>
      <main className={classes['main-content']}>
        <section id="" className={classes['project-content']}>

          <h1>Eco-Rolling AI <br/> Inteligencia y automatización al servicio de la experiencia turística.</h1>
          <p className={classes['mb-1']}>
          <strong>Eco-Rolling AI</strong> es una suite de IA modular y basada en agentes que
            <strong>transforma la complejidad operativa en eficiencia sostenible</strong>
           y experiencias de viaje fluidas, garantizando
            <strong>rentabilidad</strong> y armonía con el medio ambiente operacional.
          </p>

          <hr className={classes['bh-divider']}/>
          <h2 className={classes['project-subtitle2']}> Eco-Rolling Intelligent Planner Travel </h2>
          <p>

            The <strong>Intelligent Planner Travel </strong> system is an agentic network of
            collaborating AI modules designed to <strong>transform </strong>
            raw travel aspirations into
            <strong> perfectly executed, successful journeys.</strong>
            It operates proactively, learning from every interaction and
            taking autonomous action to optimize plans in real-time for the
            <strong> Traveler, the Agency, and the Operator </strong>simultaneously.

          </p>
          <img src={planner} alt="Intelligent Planner travel" className={classes['img-tech']}/>

          <h2 className={classes['project-subtitle2']}> Eco-Rolling conexión inteligente </h2>
          <p > El objetivo principal del módulo es garantizar una comunicación fluida, clara y
             emocionalmente inteligente entre todas las partes,
              independientemente del idioma o el canal de comunicación.</p>

          <img src={chat} alt="Intelligent Connect" className={classes['img-tech']}/>
        </section>

      </main>
    </div>

  );
};
export default Tourism;